import LocalStorageCollection from "../prototypes/LocalStorageCollection";
import CountryModel from "./CountryModel";
import { urlWithSyncVersion } from "@src/backbone/prototypes/ObjectPrototype";
//
// Collection Country
//

class CountryCollection extends LocalStorageCollection<CountryModel> {
  name = "CountryCollection";
  route = "apiCountryCollection";
  idAttribute = "id_country";
  model = CountryModel;

  initialize(
    models?: Record<string, any>[] | CountryModel[],
    options?: any
  ): void {
    // ObjectCollection constructor heritage
    const collection = this;
    super.initialize.apply(collection, [models, options]);
    //
    collection.on("sync", collection.onSync, collection);
  }

  onSync() {}
}

CountryCollection.prototype.name = "CountryCollection";
CountryCollection.prototype.route = "apiCountryCollection";
CountryCollection.prototype.url = () => urlWithSyncVersion("/country");
CountryCollection.prototype.model = CountryModel;

export default CountryCollection;
